import React from 'react';
import { createChatBotMessage } from 'react-chatbot-kit';
import CustomAvatar from './CustomAvatar';
import CustomChatMessage from './CustomChatMessage';
import { APIStatusWidget } from './widgets/APIStatusWidget';
import ChatWidget from './widgets/ChatWidget';

export const INITIAL_CHATBOT_MESSAGE =
  'Welcome to Generative Market Analysis! Please type in your question below or select one of the starter questions.';

// Example of a markdown message for testing purposes
// export const INITIAL_CHATBOT_MESSAGE = `
// # Welcome to Generative Market Analysis!
// ## Please type in your question below or select one of the starter questions.
// ## Header 3
// **Bold text**\n
// *Italic text*\n
// __Strong text__\n
// 1. An ordered list text
// - An unordered list text\n
// A direct URL: https://www.copycat.dev/\n
// ~~strikethrough text~~ \n
// > "Blockquote text"
// #### Task List:
// - [ ] Task list 1
// - [ ] Pending task list 2
// - [x] Completed task list 3
// - [x] Completed task list 4
// #### A table:
// | ID | Pet | Image |
// |--|--|--|
// | 1 | Dog |![A dog looking at you](https://images.unsplash.com/photo-1453227588063-bb302b62f50b?auto=format&fit=crop&q=60&w=800&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8ZnVubnklMjBraXR0ZW58ZW58MHx8MHx8fDA%3D)|
// | 2 | Cat |![A cat looking at you](https://images.unsplash.com/photo-1533743983669-94fa5c4338ec?auto=format&fit=crop&q=60&w=800&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8ZnVubnklMjBraXR0ZW58ZW58MHx8MHx8fDA%3D)|
// `;

// This is the configuration for the chatbot
// Docs for config: https://fredrikoseberg.github.io/react-chatbot-kit-docs/docs/advanced/configuration
const config = {
  // The initial message that the bot sends when it starts
  initialMessages: [createChatBotMessage(INITIAL_CHATBOT_MESSAGE, { widget: 'initWidget' })],
  state: {
    intIntent: '',
    intPlan: [],
    currentStep: '',
    showResponseSugestionsPopup: false,
  },
  widgets: [
    {
      widgetName: 'chatWidget', // main chat widget that includes other widget states
      widgetFunc: ChatWidget,
      mapStateToProps: [],
      props: [],
    },
    {
      widgetName: 'initWidget', // initial widget (welcome message) with suggestions widget
      widgetFunc: ChatWidget,
      mapStateToProps: [],
      props: { init: true },
    },
    {
      widgetName: 'intSteps', // intermediate steps (loading) widget
      widgetFunc: APIStatusWidget,
      mapStateToProps: ['intIntent', 'intPlan', 'currentStep'],
      props: [],
    },
    {
      widgetName: 'chatHistoryActiveChatWidget', // chat widget with suggestions widget when clicked on chat history
      widgetFunc: ChatWidget,
      mapStateToProps: [],
      props: { chatHistoryActive: true },
    },
  ],
  customComponents: {
    botAvatar: (props) => <CustomAvatar {...props} />,
    userAvatar: (props) => <CustomAvatar {...props} userAvatar={true} />,
    botChatMessage: (props) => <CustomChatMessage {...props} />,
  },
};

export default config;
